// import React, { useState, useEffect } from 'react';
import '../css/homecontentin.css'
import OddDays from './odd-days'
import TheBar from './the-bar'

function HomeContentIn({nowMonth, nowYear, selectedMonth, currentDay, currentYear, currentMonth, monthUserEvents, nameToDisplay, dateToDisplay, ageToDisplay, zodiacToDisplay, isEditing, setisEditing, setnameToEdit, setdateToEdit, setidToEdit }) {

  return (
    <>
      <div id="main-header">

        <OddDays currentYear={currentYear} currentMonth={currentMonth} monthUserEvents={monthUserEvents} setnameToEdit={setnameToEdit} setdateToEdit={setdateToEdit} setidToEdit={setidToEdit} setisEditing={setisEditing} isEditing={isEditing} nameToDisplay={nameToDisplay} dateToDisplay={dateToDisplay} ageToDisplay={ageToDisplay} zodiacToDisplay={zodiacToDisplay} />

        <TheBar nowMonth={nowMonth} nowYear={nowYear} selectedMonth={selectedMonth} currentDay={currentDay} currentYear={currentYear} currentMonth={currentMonth} />

      </div>
    </>
  )
}

export default HomeContentIn;
